<template>
  <div class="hemorrhage public-content">
    <div class="breadcrumb">出血类型</div>
    <div class="search">
      <div>
        <p>
          <span>出血类型：</span>
          <el-input v-model="bleedName" style="180px" clearable placeholder="请输入出血类型"></el-input>
        </p>
      </div>
      <div>
        <el-button round @click="queryInfo.pageNum = 1, getBleed(queryInfo)">查询</el-button>
        <el-button round type="primary" @click="addHemorrhage('add')" v-permission="'pts:admin:bleed:add'">添加</el-button>
      </div>
    </div>
    <div class="right-main">
      <div class="data-list">
        <el-table :data="hemorrhageList" border style="width: 100%">
          <el-table-column prop="bleedName" label="出血类型" min-width="180"></el-table-column>
          <el-table-column label="出血" min-width="180">
            <template v-slot="scope"> 上方：{{ scope.row.bleedTop }}mm 下方：{{ scope.row.bleedBottom }}mm <br> 左侧：{{ scope.row.bleedLeft }}mm 右侧：{{ scope.row.bleedRight }}mm <br> 内侧：{{ scope.row.bleedIn }}mm
            </template>
          </el-table-column>
          <el-table-column prop="name" label="操作" min-width="180">
            <template v-slot="scope">
              <span class="color-blue" @click="addHemorrhage('edit', scope.row)" v-permission="'pts:admin:bleed:update'">编辑</span>
              <span class="color-blue" style="margin-left: 10px;" @click="deleteBleed(scope.row.id)" v-permission="'pts:admin:bleed:delete'">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--    分页-->
    <v-pagination class="v-pagination" :queryInfo="queryInfo" v-if="queryInfo.total !== ''" @changePage="changePage"></v-pagination>
    <CombinedDialog ref="dialogRef" @delete="deleteBleedOk"></CombinedDialog>
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index'
import CombinedDialog from '@/components/Dialog/CombinedDialog/index'
import { bleedListPaging } from '@/api/pms'
export default {
  name: 'hemorrhage',
  components: {
    VPagination,
    CombinedDialog
  },
  data () {
    return {
      bleedName: '',
      hemorrhageList: [],
      queryInfo: {
        type: 3,
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      }
    }
  },
  created () {
    if (sessionStorage.getItem('searchFlag') === 'true') {
      this.bleedName = JSON.parse(sessionStorage.getItem('queryParams'))
      this.queryInfo = JSON.parse(sessionStorage.getItem('queryInfo'))
      sessionStorage.removeItem('searchFlag')
    } else {
      // 首次进入列表页,清除缓存中的搜索条件
      sessionStorage.removeItem('queryParams')
      sessionStorage.removeItem('queryInfo')
    }
    this.getBleed(this.queryInfo)
  },
  destroyed () {
    // 销毁
    console.log('页面销毁')
    sessionStorage.removeItem('searchFlag')
  },
  methods: {
    addHemorrhage (val, row) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.bleedName))
      if (val === 'add') {
        this.$router.push('./addhemorrhage')
      }
      if (val === 'edit') {
        this.$router.push({
          path: './addhemorrhage',
          query: {
            id: row.id
          }
        })
      }
    },
    getBleed (val) {
      if (sessionStorage.getItem('searchFlag')) {
        sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
        sessionStorage.setItem('queryParams', JSON.stringify(this.bleedName))
      }
      bleedListPaging({ pageNum: val.pageNum, pageSize: val.pageSize, bleedName: this.bleedName }).then((res) => {
        if (res.data.success) {
          if (res.data.data.records.length === 0 && res.data.data.total !== 0 && this.queryInfo.pageNum !== 1) {
            this.queryInfo.pageNum--
            this.getBleed(this.queryInfo)
          }
          this.hemorrhageList = res.data.data.records
          this.queryInfo.total = res.data.data.total
        } else {
        }
      })
    },
    changePage (val) {
      this.queryInfo = val
      this.getBleed(this.queryInfo)
    },
    deleteBleed (id) {
      this.$refs.dialogRef.show('delete', '确定提示', '删除确定<br><span style="color: #999">是否确定删除</span>',
        '', 'delete', '/api/pms/admin/bleed/delete/' + `${id}`)
    },
    deleteBleedOk () {
      this.getBleed(this.queryInfo)
    }
  }
}
</script>
<style scoped lang="less">
@deep: ~">>>";

.search {
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;

  p {
    width: 250px;
    display: flex;
    align-items: center;

    @{deep} .el-input {
      width: 180px;
    }
  }
}
</style>
